function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, DatePicker, Space, InputNumber, Radio, Checkbox, Divider, Alert, Upload, Tabs, Image, Modal, notification } from "antd";
import { Container, Row, Col, Table } from "react-bootstrap";
import Common from "../includes/Common";
import moment from "moment";
import { Upload as UploadIcon, PersonLock, CardChecklist } from "react-bootstrap-icons";
import Moment from "react-moment";
import SignaturePad from "../SignaturePad";
import SignaturePadNoVaccin from "../SignaturePadNoVaccin";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CheckboxGroup = Checkbox.Group;
var TextArea = Input.TextArea;
var MedFormFhPe = function MedFormFhPe(_ref) {
  var candidat = _ref.candidat,
    _ref$formType = _ref.formType,
    formType = _ref$formType === void 0 ? null : _ref$formType,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? 0 : _ref$readOnly,
    handler = _ref.handler;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormProcessing = _useState4[0],
    setIsFormProcessing = _useState4[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showSignaturePad = _useState8[0],
    setShowSignaturePad = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showNoVaccinSignaturePad = _useState0[0],
    setShowNoVaccinSignaturePad = _useState0[1];
  var _useState1 = useState(candidat.medecine_questions != null ? candidat.medecine_questions.signature : null),
    _useState10 = _slicedToArray(_useState1, 2),
    signatureIm = _useState10[0],
    setSignatureIm = _useState10[1];
  var _useState11 = useState(candidat.medecine_questions != null ? candidat.medecine_questions.signaturenv : null),
    _useState12 = _slicedToArray(_useState11, 2),
    signatureNoVaccin = _useState12[0],
    setSignatureNoVaccin = _useState12[1];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setErrorMessage("");
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("form_type", formType);

    //1. Antécédents familiaux
    formData.append("has_heart_disease_high_bp", values.has_heart_disease_high_bp);
    formData.append("has_epilepsy", values.has_epilepsy);
    formData.append("has_glaucom", values.has_glaucom);
    formData.append("has_diabete", values.has_diabete);
    formData.append("has_cancer_blood_disease", values.has_cancer_blood_disease);
    formData.append("has_hereditary_disease", values.has_hereditary_disease);
    formData.append("has_breath_disease", values.has_breath_disease);
    formData.append("precisions_ant_family", values.precisions_ant_family);

    //2. Antécédents médicaux

    formData.append("has_frequent_headach", values.has_frequent_headach);
    formData.append("has_dizziness", values.has_dizziness);
    formData.append("has_trauma", values.has_trauma);
    formData.append("has_med_epilepsy", values.has_med_epilepsy);
    formData.append("has_mental_trouble", values.has_mental_trouble);
    formData.append("has_heart_trouble", values.has_heart_trouble);
    formData.append("has_hyper_ta", values.has_hyper_ta);
    formData.append("has_asthma", values.has_asthma);
    formData.append("has_tb_pneumonia", values.has_tb_pneumonia);
    formData.append("has_orl_trouble", values.has_orl_trouble);
    formData.append("has_speak_trouble", values.has_speak_trouble);
    formData.append("has_tumor_cancer", values.has_tumor_cancer);
    formData.append("has_skin_trouble", values.has_skin_trouble);
    formData.append("has_bone_disease", values.has_bone_disease);
    formData.append("has_kidney_stones", values.has_kidney_stones);
    formData.append("has_prostate_trouble", values.has_prostate_trouble);
    formData.append("is_pregnant", values.is_pregnant);
    formData.append("has_gastro_inflammation", values.has_gastro_inflammation);
    formData.append("has_gastro_trouble", values.has_gastro_trouble);
    formData.append("has_rectal_bleed", values.has_rectal_bleed);
    formData.append("has_med_diabete", values.has_med_diabete);
    formData.append("has_thyroid_disease", values.has_thyroid_disease);
    formData.append("has_blood_diseases", values.has_blood_diseases);
    formData.append("has_sti", values.has_sti);
    formData.append("ant_med_others", values.ant_med_others);
    formData.append("has_allergy", values.has_allergy);
    formData.append("has_been_hospitalized", values.has_been_hospitalized);
    formData.append("has_done_surgery", values.has_done_surgery);
    formData.append("has_tropical_disease", values.has_tropical_disease);
    formData.append("has_eye_trouble", values.has_eye_trouble);
    formData.append("has_med_cancer_tumor", values.has_med_cancer_tumor);
    formData.append("is_workspace_harmful", values.is_workspace_harmful);
    formData.append("has_weight_loss", values.has_weight_loss);
    formData.append("precisions_ant_med", values.precisions_ant_med);

    //3. Histoire sociale
    formData.append("is_alcoholic", values.is_alcoholic);
    formData.append("use_intertainment_drugs", values.use_intertainment_drugs);
    formData.append("do_sport_hobbies", values.do_sport_hobbies);
    formData.append("smokes_tobacco", values.smokes_tobacco);
    formData.append("alcohol_frequency", values.alcohol_frequency);
    formData.append("alcohol_quantity", values.alcohol_quantity);
    formData.append("cigaret_quantity_day", values.cigaret_quantity_day);
    formData.append("sport_type_frequency", values.sport_type_frequency);
    formData.append("comment_social", values.comment_social);

    //4. Bilan psychologique
    formData.append("has_advise_work_avoid", values.has_advise_work_avoid);
    formData.append("has_nervous_trouble", values.has_nervous_trouble);
    formData.append("has_attend_psycho_specialist", values.has_attend_psycho_specialist);
    formData.append("is_acrophobic_claustrophobic", values.is_acrophobic_claustrophobic);
    formData.append("has_aknowledge_work_incapacity", values.has_aknowledge_work_incapacity);
    formData.append("has_aknowledge_tasks_security_requirement", values.has_aknowledge_tasks_security_requirement);
    formData.append("has_attempt_suicide", values.has_attempt_suicide);
    formData.append("has_frequent_depression", values.has_frequent_depression);
    formData.append("has_transmitted_thinkings", values.has_transmitted_thinkings);
    formData.append("has_super_powers", values.has_super_powers);
    formData.append("has_frequent_irritation", values.has_frequent_irritation);
    formData.append("has_frequent_nervous_nocontrol", values.has_frequent_nervous_nocontrol);
    formData.append("is_known_quarrelsome", values.is_known_quarrelsome);
    formData.append("has_frequent_hustle_nervous", values.has_frequent_hustle_nervous);
    formData.append("precisions_psycho", values.precisions_psycho);

    // 5. Respiration/tuberculose
    formData.append("has_frequent_morning_cough", values.has_frequent_morning_cough);
    formData.append("has_frequent_day_night_cough", values.has_frequent_day_night_cough);
    formData.append("has_frequent_mucositis_day_night", values.has_frequent_mucositis_day_night);
    formData.append("has_spit_blood", values.has_spit_blood);
    formData.append("feel_chest_tighten", values.feel_chest_tighten);
    formData.append("is_bothered_shortness_breath", values.is_bothered_shortness_breath);
    formData.append("has_day_worse_shortness_breath", values.has_day_worse_shortness_breath);
    formData.append("has_chest_whistle", values.has_chest_whistle);
    formData.append("has_last_three_years_chest_disease", values.has_last_three_years_chest_disease);
    formData.append("has_chest_injury_surgery", values.has_chest_injury_surgery);
    formData.append("has_heart_disease_tb", values.has_heart_disease_tb);
    formData.append("has_bronchitis_pneumonia_pleurisy", values.has_bronchitis_pneumonia_pleurisy);
    formData.append("has_pulmonary_tb_asthma", values.has_pulmonary_tb_asthma);
    formData.append("precisions_tb", values.precisions_tb);

    //6. Traitement médicamenteux
    formData.append("current_medication_type_dosage", values.current_medication_type_dosage);
    formData.append("allergy_food", values.allergy_food);
    formData.append("allergy_drug", values.allergy_drug);
    formData.append("chemical_products", values.chemical_products);
    formData.append("allergy_others", values.allergy_others);

    //QUESTIONNAIRE SUR LA SANTÉ AU TRAVAIL 
    formData.append("has_exposed_chemical", values.has_exposed_chemical);
    formData.append("chemical_exposition_delay", values.chemical_exposition_delay);
    formData.append("used_chemical_protection", values.used_chemical_protection);
    formData.append("has_exposed_noise", values.has_exposed_noise);
    formData.append("has_exposed_noise_delay", values.has_exposed_noise_delay);
    formData.append("has_exposed_noise_protection", values.has_exposed_noise_protection);
    formData.append("has_exposed_vibrations", values.has_exposed_vibrations);
    formData.append("has_exposed_vibrations_delay", values.has_exposed_vibrations_delay);
    formData.append("has_exposed_vibrations_protection", values.has_exposed_vibrations_protection);
    formData.append("has_exposed_radioactivity", values.has_exposed_radioactivity);
    formData.append("has_exposed_radioactivity_delay", values.has_exposed_radioactivity_delay);
    formData.append("has_exposed_radioactivity_protections", values.has_exposed_radioactivity_protections);
    formData.append("has_exposed_asbestos_dust", values.has_exposed_asbestos_dust);
    formData.append("has_exposed_asbestos_dust_delay", values.has_exposed_asbestos_dust_delay);
    formData.append("has_exposed_asbestos_dust_protection", values.has_exposed_asbestos_dust_protection);
    formData.append("has_exposed_lead", values.has_exposed_lead);
    formData.append("has_exposed_lead_delay", values.has_exposed_lead_delay);
    formData.append("has_exposed_lead_protection", values.has_exposed_lead_protection);
    formData.append("has_exposed_other_dust", values.has_exposed_other_dust);
    formData.append("has_exposed_other_dust_delay", values.has_exposed_other_dust_delay);
    formData.append("has_exposed_other_dust_protection", values.has_exposed_other_dust_protection);
    formData.append("has_last_year_absent_count", values.has_last_year_absent_count);
    formData.append("has_last_year_absent_reason", values.has_last_year_absent_reason);
    formData.append("has_last_year_absent", values.has_last_year_absent);
    formData.append("has_work_injury_inquiry_compensation", values.has_work_injury_inquiry_compensation);
    formData.append("work_injury_reason", values.work_injury_reason);
    formData.append("work_injury_treatment", values.work_injury_treatment);
    formData.append("work_injury_stills", values.work_injury_stills);
    formData.append("work_injury_stills_manifestation", values.work_injury_stills_manifestation);
    formData.append("has_work_heavy_engin", values.has_work_heavy_engin);
    formData.append("has_work_lifting_bending", values.has_work_lifting_bending);
    formData.append("has_work_surface_light", values.has_work_surface_light);
    formData.append("has_work_stand_long", values.has_work_stand_long);
    formData.append("has_work_drive_passengers", values.has_work_drive_passengers);
    formData.append("has_work_office", values.has_work_office);
    formData.append("has_work_confined", values.has_work_confined);
    formData.append("has_work_height", values.has_work_height);
    formData.append("has_work_wildlife", values.has_work_wildlife);
    formData.append("has_work_sea", values.has_work_sea);
    formData.append("has_work_underground", values.has_work_underground);
    formData.append("has_work_high_temperature", values.has_work_high_temperature);

    //EXAMEN MÉDICAL
    formData.append("height", values.height);
    formData.append("weight", values.weight);
    formData.append("imc", values.imc);
    formData.append("temperature", values.temperature);
    formData.append("eye_normal", values.eye_normal);
    formData.append("orl_normal", values.orl_normal);
    formData.append("teeth_mouth_normal", values.teeth_mouth_normal);
    formData.append("breathe_normal", values.breathe_normal);
    formData.append("cardiovascular_normal", values.cardiovascular_normal);
    formData.append("abdomen_normal", values.abdomen_normal);
    formData.append("musculoskeletal_normal", values.musculoskeletal_normal);
    formData.append("ends_normal", values.ends_normal);
    formData.append("genitourinary_normal", values.genitourinary_normal);
    formData.append("comment_clinical_observation", values.comment_clinical_observation);
    formData.append("arterial_pressure", values.arterial_pressure);
    formData.append("breathe_frequency", values.breathe_frequency);
    formData.append("cardiac_frequency", values.cardiac_frequency);
    formData.append("heartbeat", values.heartbeat);

    //LABO
    formData.append("glucose", values.glucose);
    formData.append("blood", values.blood);
    formData.append("bilirubine", values.bilirubine);
    formData.append("leucocytes", values.leucocytes);
    formData.append("cetone", values.cetone);
    formData.append("proteine", values.proteine);
    formData.append("blood_formula_normal", values.blood_formula_normal);
    formData.append("glycemy_normal", values.glycemy_normal);
    formData.append("uree_normal", values.uree_normal);
    formData.append("creatine_normal", values.creatine_normal);
    formData.append("serology_ha_normal", values.serology_ha_normal);
    formData.append("serology_hb_normal", values.serology_hb_normal);
    formData.append("selle_normal", values.selle_normal);
    formData.append("idr_normal", values.idr_normal);
    formData.append("cholesterol_normal", values.cholesterol_normal);
    formData.append("triglyceride_normal", values.triglyceride_normal);
    formData.append("alat_asat_normal", values.alat_asat_normal);
    formData.append("gamma_gt_normal", values.gamma_gt_normal);

    //DRUG
    formData.append("amphetamine_positive", values.amphetamine_positive);
    formData.append("benzodiazepine_positive", values.benzodiazepine_positive);
    formData.append("cannabinoide_positive", values.cannabinoide_positive);
    formData.append("opiace_positive", values.opiace_positive);
    formData.append("cocain_positive", values.cocain_positive);

    //IM
    formData.append("rest_ecg_normal", values.rest_ecg_normal);
    formData.append("effort_ecg_normal", values.effort_ecg_normal);
    formData.append("radio_normal", values.radio_normal);

    //VISION
    formData.append("chrome_vision_normal", values.chrome_vision_normal);
    formData.append("woglass_right_far", values.woglass_right_far);
    formData.append("woglass_right_near", values.woglass_right_near);
    formData.append("wglass_right", values.wglass_right);
    formData.append("visual_area_normal", values.visual_area_normal);
    formData.append("woglass_left_far", values.woglass_left_far);
    formData.append("woglass_left_near", values.woglass_left_near);
    formData.append("wglass_left", values.wglass_left);
    formData.append("cvf_measured", values.cvf_measured);
    formData.append("vems_one_measured", values.vems_one_measured);
    formData.append("vems_percent_measured", values.vems_percent_measured);
    formData.append("cvf_forecasted", values.cvf_forecasted);
    formData.append("vems_one_forecasted", values.vems_one_forecasted);
    formData.append("vems_percent_forcasted", values.vems_percent_forcasted);
    formData.append("cvf_percent_forcasted", values.cvf_percent_forcasted);
    formData.append("vems_one_percent_forcasted", values.vems_one_percent_forcasted);
    formData.append("vems_percent_percent_forcasted", values.vems_percent_percent_forcasted);
    formData.append("comments_spiro", values.comments_spiro);
    formData.append("left_ear_normal", values.left_ear_normal);
    formData.append("left_ear_comment", values.left_ear_comment);
    formData.append("right_ear_normal", values.right_ear_normal);
    formData.append("right_ear_comments", values.right_ear_comments);
    formData.append("ipa", values.ipa);
    formData.append("immuned_yf", values.immuned_yf);
    formData.append("immuned_yf_date", values.immuned_yf_date);
    formData.append("immuned_yf_comments", values.immuned_yf_comments);
    formData.append("immuned_ha", values.immuned_ha);
    formData.append("immuned_ha_date", values.immuned_ha_date);
    formData.append("immuned_ha_comments", values.immuned_ha_comments);
    formData.append("immuned_hb", values.immuned_hb);
    formData.append("immuned_hb_date", values.immuned_hb_date);
    formData.append("immuned_hb_comments", values.immuned_hb_comments);
    formData.append("immuned_typhoid", values.immuned_typhoid);
    formData.append("immuned_typhoid_date", values.immuned_typhoid_date);
    formData.append("immuned_typhoid_comments", values.immuned_typhoid_comments);
    formData.append("immuned_meningite", values.immuned_meningite);
    formData.append("immuned_meningite_date", values.immuned_meningite_date);
    formData.append("immuned_meningite_comments", values.immuned_meningite_comments);
    formData.append("immuned_diph", values.immuned_diph);
    formData.append("immuned_diph_date", values.immuned_diph_date);
    formData.append("immuned_diph_comments", values.immuned_diph_comments);
    formData.append("immuned_teta", values.immuned_teta);
    formData.append("immuned_teta_date", values.immuned_teta_date);
    formData.append("immuned_teta_comments", values.immuned_teta_comments);
    formData.append("immuned_covid", values.immuned_covid);
    formData.append("immuned_covid_date", values.immuned_covid_date);
    formData.append("immuned_covid_comments", values.immuned_covid_comments);
    formData.append("immuned_polio", values.immuned_polio);
    formData.append("immuned_polio_date", values.immuned_polio_date);
    formData.append("immuned_polio_comments", values.immuned_polio_comments);
    formData.append("immuned_menin", values.immuned_menin);
    formData.append("immuned_menin_date", values.immuned_menin_date);
    formData.append("immuned_menin_comments", values.immuned_menin_comments);
    formData.append("immuned_rage", values.immuned_rage);
    formData.append("immuned_rage_date", values.immuned_rage_date);
    formData.append("immuned_rage_comments", values.immuned_rage_comments);
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    axios.post(Common.baseApiUrl + "setmedicalcheck", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (candidat.medecine_questions_id != null) {
      form.setFieldsValue({
        has_heart_disease_high_bp: candidat.medecine_questions.has_heart_disease_high_bp,
        has_epilepsy: candidat.medecine_questions.has_epilepsy,
        has_glaucom: candidat.medecine_questions.has_glaucom,
        has_diabete: candidat.medecine_questions.has_diabete,
        has_cancer_blood_disease: candidat.medecine_questions.has_cancer_blood_disease,
        has_hereditary_disease: candidat.medecine_questions.has_hereditary_disease,
        has_breath_disease: candidat.medecine_questions.has_breath_disease,
        precisions_ant_family: candidat.medecine_questions.precisions_ant_family,
        has_frequent_headach: candidat.medecine_questions.has_frequent_headach,
        has_dizziness: candidat.medecine_questions.has_dizziness,
        has_trauma: candidat.medecine_questions.has_trauma,
        has_med_epilepsy: candidat.medecine_questions.has_med_epilepsy,
        has_mental_trouble: candidat.medecine_questions.has_mental_trouble,
        has_heart_trouble: candidat.medecine_questions.has_heart_trouble,
        has_hyper_ta: candidat.medecine_questions.has_hyper_ta,
        has_asthma: candidat.medecine_questions.has_asthma,
        has_tb_pneumonia: candidat.medecine_questions.has_tb_pneumonia,
        has_orl_trouble: candidat.medecine_questions.has_orl_trouble,
        has_speak_trouble: candidat.medecine_questions.has_speak_trouble,
        has_tumor_cancer: candidat.medecine_questions.has_tumor_cancer,
        has_skin_trouble: candidat.medecine_questions.has_skin_trouble,
        has_bone_disease: candidat.medecine_questions.has_bone_disease,
        has_kidney_stones: candidat.medecine_questions.has_kidney_stones,
        has_prostate_trouble: candidat.medecine_questions.has_prostate_trouble,
        is_pregnant: candidat.medecine_questions.is_pregnant,
        has_gastro_inflammation: candidat.medecine_questions.has_gastro_inflammation,
        has_gastro_trouble: candidat.medecine_questions.has_gastro_trouble,
        has_rectal_bleed: candidat.medecine_questions.has_rectal_bleed,
        has_med_diabete: candidat.medecine_questions.has_med_diabete,
        has_thyroid_disease: candidat.medecine_questions.has_thyroid_disease,
        has_blood_diseases: candidat.medecine_questions.has_blood_diseases,
        has_sti: candidat.medecine_questions.has_sti,
        ant_med_others: candidat.medecine_questions.ant_med_others,
        has_allergy: candidat.medecine_questions.has_allergy,
        has_been_hospitalized: candidat.medecine_questions.has_been_hospitalized,
        has_done_surgery: candidat.medecine_questions.has_done_surgery,
        has_tropical_disease: candidat.medecine_questions.has_tropical_disease,
        has_eye_trouble: candidat.medecine_questions.has_eye_trouble,
        has_med_cancer_tumor: candidat.medecine_questions.has_med_cancer_tumor,
        is_workspace_harmful: candidat.medecine_questions.is_workspace_harmful,
        has_weight_loss: candidat.medecine_questions.has_weight_loss,
        precisions_ant_med: candidat.medecine_questions.precisions_ant_med,
        is_alcoholic: candidat.medecine_questions.is_alcoholic,
        use_intertainment_drugs: candidat.medecine_questions.use_intertainment_drugs,
        do_sport_hobbies: candidat.medecine_questions.do_sport_hobbies,
        smokes_tobacco: candidat.medecine_questions.smokes_tobacco,
        alcohol_frequency: candidat.medecine_questions.alcohol_frequency,
        alcohol_quantity: candidat.medecine_questions.alcohol_quantity,
        cigaret_quantity_day: candidat.medecine_questions.cigaret_quantity_day,
        sport_type_frequency: candidat.medecine_questions.sport_type_frequency,
        comment_social: candidat.medecine_questions.comment_social,
        has_advise_work_avoid: candidat.medecine_questions.has_advise_work_avoid,
        has_nervous_trouble: candidat.medecine_questions.has_nervous_trouble,
        has_attend_psycho_specialist: candidat.medecine_questions.has_attend_psycho_specialist,
        is_acrophobic_claustrophobic: candidat.medecine_questions.is_acrophobic_claustrophobic,
        has_aknowledge_work_incapacity: candidat.medecine_questions.has_aknowledge_work_incapacity,
        has_aknowledge_tasks_security_requirement: candidat.medecine_questions.has_aknowledge_tasks_security_requirement,
        has_attempt_suicide: candidat.medecine_questions.has_attempt_suicide,
        has_frequent_depression: candidat.medecine_questions.has_frequent_depression,
        has_transmitted_thinkings: candidat.medecine_questions.has_transmitted_thinkings,
        has_super_powers: candidat.medecine_questions.has_super_powers,
        has_frequent_irritation: candidat.medecine_questions.has_frequent_irritation,
        has_frequent_nervous_nocontrol: candidat.medecine_questions.has_frequent_nervous_nocontrol,
        is_known_quarrelsome: candidat.medecine_questions.is_known_quarrelsome,
        has_frequent_hustle_nervous: candidat.medecine_questions.has_frequent_hustle_nervous,
        precisions_psycho: candidat.medecine_questions.precisions_psycho,
        has_frequent_morning_cough: candidat.medecine_questions.has_frequent_morning_cough,
        has_frequent_day_night_cough: candidat.medecine_questions.has_frequent_day_night_cough,
        has_frequent_mucositis_day_night: candidat.medecine_questions.has_frequent_mucositis_day_night,
        has_spit_blood: candidat.medecine_questions.has_spit_blood,
        feel_chest_tighten: candidat.medecine_questions.feel_chest_tighten,
        is_bothered_shortness_breath: candidat.medecine_questions.is_bothered_shortness_breath,
        has_day_worse_shortness_breath: candidat.medecine_questions.has_day_worse_shortness_breath,
        has_chest_whistle: candidat.medecine_questions.has_chest_whistle,
        has_last_three_years_chest_disease: candidat.medecine_questions.has_last_three_years_chest_disease,
        has_chest_injury_surgery: candidat.medecine_questions.has_chest_injury_surgery,
        has_heart_disease_tb: candidat.medecine_questions.has_heart_disease_tb,
        has_bronchitis_pneumonia_pleurisy: candidat.medecine_questions.has_bronchitis_pneumonia_pleurisy,
        has_pulmonary_tb_asthma: candidat.medecine_questions.has_pulmonary_tb_asthma,
        precisions_tb: candidat.medecine_questions.precisions_tb,
        current_medication_type_dosage: candidat.medecine_questions.current_medication_type_dosage,
        allergy_food: candidat.medecine_questions.allergy_food,
        allergy_drug: candidat.medecine_questions.allergy_drug,
        chemical_products: candidat.medecine_questions.chemical_products,
        allergy_others: candidat.medecine_questions.allergy_others,
        has_exposed_chemical: candidat.medecine_questions.has_exposed_chemical,
        chemical_exposition_delay: candidat.medecine_questions.chemical_exposition_delay,
        used_chemical_protection: candidat.medecine_questions.used_chemical_protection,
        has_exposed_noise: candidat.medecine_questions.has_exposed_noise,
        has_exposed_noise_delay: candidat.medecine_questions.has_exposed_noise_delay,
        has_exposed_noise_protection: candidat.medecine_questions.has_exposed_noise_protection,
        has_exposed_vibrations: candidat.medecine_questions.has_exposed_vibrations,
        has_exposed_vibrations_delay: candidat.medecine_questions.has_exposed_vibrations_delay,
        has_exposed_vibrations_protection: candidat.medecine_questions.has_exposed_vibrations_protection,
        has_exposed_radioactivity: candidat.medecine_questions.has_exposed_radioactivity,
        has_exposed_radioactivity_delay: candidat.medecine_questions.has_exposed_radioactivity_delay,
        has_exposed_radioactivity_protections: candidat.medecine_questions.has_exposed_radioactivity_protections,
        has_exposed_asbestos_dust: candidat.medecine_questions.has_exposed_asbestos_dust,
        has_exposed_asbestos_dust_delay: candidat.medecine_questions.has_exposed_asbestos_dust_delay,
        has_exposed_asbestos_dust_protection: candidat.medecine_questions.has_exposed_asbestos_dust_protection,
        has_exposed_lead: candidat.medecine_questions.has_exposed_lead,
        has_exposed_lead_delay: candidat.medecine_questions.has_exposed_lead_delay,
        has_exposed_lead_protection: candidat.medecine_questions.has_exposed_lead_protection,
        has_exposed_other_dust: candidat.medecine_questions.has_exposed_other_dust,
        has_exposed_other_dust_delay: candidat.medecine_questions.has_exposed_other_dust_delay,
        has_exposed_other_dust_protection: candidat.medecine_questions.has_exposed_other_dust_protection,
        has_last_year_absent_count: candidat.medecine_questions.has_last_year_absent_count,
        has_last_year_absent_reason: candidat.medecine_questions.has_last_year_absent_reason,
        has_last_year_absent: candidat.medecine_questions.has_last_year_absent,
        has_work_injury_inquiry_compensation: candidat.medecine_questions.has_work_injury_inquiry_compensation,
        work_injury_reason: candidat.medecine_questions.work_injury_reason,
        work_injury_treatment: candidat.medecine_questions.work_injury_treatment,
        work_injury_stills: candidat.medecine_questions.work_injury_stills,
        work_injury_stills_manifestation: candidat.medecine_questions.work_injury_stills_manifestation,
        has_work_heavy_engin: candidat.medecine_questions.has_work_heavy_engin,
        has_work_lifting_bending: candidat.medecine_questions.has_work_lifting_bending,
        has_work_surface_light: candidat.medecine_questions.has_work_surface_light,
        has_work_stand_long: candidat.medecine_questions.has_work_stand_long,
        has_work_drive_passengers: candidat.medecine_questions.has_work_drive_passengers,
        has_work_office: candidat.medecine_questions.has_work_office,
        has_work_confined: candidat.medecine_questions.has_work_confined,
        has_work_height: candidat.medecine_questions.has_work_height,
        has_work_wildlife: candidat.medecine_questions.has_work_wildlife,
        has_work_sea: candidat.medecine_questions.has_work_sea,
        has_work_underground: candidat.medecine_questions.has_work_underground,
        has_work_high_temperature: candidat.medecine_questions.has_work_high_temperature,
        height: candidat.medecine_questions.height,
        weight: candidat.medecine_questions.weight,
        temperature: candidat.medecine_questions.temperature,
        eye_normal: candidat.medecine_questions.eye_normal,
        orl_normal: candidat.medecine_questions.orl_normal,
        teeth_mouth_normal: candidat.medecine_questions.teeth_mouth_normal,
        breathe_normal: candidat.medecine_questions.breathe_normal,
        imc: candidat.medecine_questions.imc,
        cardiovascular_normal: candidat.medecine_questions.cardiovascular_normal,
        abdomen_normal: candidat.medecine_questions.abdomen_normal,
        musculoskeletal_normal: candidat.medecine_questions.musculoskeletal_normal,
        ends_normal: candidat.medecine_questions.ends_normal,
        genitourinary_normal: candidat.medecine_questions.genitourinary_normal,
        comment_clinical_observation: candidat.medecine_questions.comment_clinical_observation,
        arterial_pressure: candidat.medecine_questions.arterial_pressure,
        breathe_frequency: candidat.medecine_questions.breathe_frequency,
        cardiac_frequency: candidat.medecine_questions.cardiac_frequency,
        heartbeat: candidat.medecine_questions.heartbeat,
        //LABO
        glucose: candidat.medecine_questions.glucose,
        blood: candidat.medecine_questions.blood,
        bilirubine: candidat.medecine_questions.bilirubine,
        leucocytes: candidat.medecine_questions.leucocytes,
        cetone: candidat.medecine_questions.cetone,
        proteine: candidat.medecine_questions.proteine,
        blood_formula_normal: candidat.medecine_questions.blood_formula_normal,
        glycemy_normal: candidat.medecine_questions.glycemy_normal,
        uree_normal: candidat.medecine_questions.uree_normal,
        creatine_normal: candidat.medecine_questions.creatine_normal,
        serology_ha_normal: candidat.medecine_questions.serology_ha_normal,
        serology_hb_normal: candidat.medecine_questions.serology_hb_normal,
        selle_normal: candidat.medecine_questions.selle_normal,
        idr_normal: candidat.medecine_questions.idr_normal,
        cholesterol_normal: candidat.medecine_questions.cholesterol_normal,
        triglyceride_normal: candidat.medecine_questions.triglyceride_normal,
        alat_asat_normal: candidat.medecine_questions.alat_asat_normal,
        gamma_gt_normal: candidat.medecine_questions.gamma_gt_normal,
        //DRUG
        amphetamine_positive: candidat.medecine_questions.amphetamine_positive,
        benzodiazepine_positive: candidat.medecine_questions.benzodiazepine_positive,
        cannabinoide_positive: candidat.medecine_questions.cannabinoide_positive,
        opiace_positive: candidat.medecine_questions.opiace_positive,
        cocain_positive: candidat.medecine_questions.cocain_positive,
        //IM
        rest_ecg_normal: candidat.medecine_questions.rest_ecg_normal,
        effort_ecg_normal: candidat.medecine_questions.effort_ecg_normal,
        radio_normal: candidat.medecine_questions.radio_normal,
        //VISION
        chrome_vision_normal: candidat.medecine_questions.chrome_vision_normal,
        woglass_right_far: candidat.medecine_questions.woglass_right_far,
        woglass_right_near: candidat.medecine_questions.woglass_right_near,
        wglass_right: candidat.medecine_questions.wglass_right,
        visual_area_normal: candidat.medecine_questions.visual_area_normal,
        woglass_left_far: candidat.medecine_questions.woglass_left_far,
        woglass_left_near: candidat.medecine_questions.woglass_left_near,
        wglass_left: candidat.medecine_questions.wglass_left,
        cvf_measured: candidat.medecine_questions.cvf_measured,
        vems_one_measured: candidat.medecine_questions.vems_one_measured,
        vems_percent_measured: candidat.medecine_questions.vems_percent_measured,
        cvf_forecasted: candidat.medecine_questions.cvf_forecasted,
        vems_one_forecasted: candidat.medecine_questions.vems_one_forecasted,
        vems_percent_forcasted: candidat.medecine_questions.vems_percent_forcasted,
        cvf_percent_forcasted: candidat.medecine_questions.cvf_percent_forcasted,
        vems_one_percent_forcasted: candidat.medecine_questions.vems_one_percent_forcasted,
        vems_percent_percent_forcasted: candidat.medecine_questions.vems_percent_percent_forcasted,
        comments_spiro: candidat.medecine_questions.comments_spiro,
        left_ear_normal: candidat.medecine_questions.left_ear_normal,
        left_ear_comment: candidat.medecine_questions.left_ear_comment,
        right_ear_normal: candidat.medecine_questions.right_ear_normal,
        right_ear_comments: candidat.medecine_questions.right_ear_comments,
        ipa: candidat.medecine_questions.ipa,
        immuned_yf: candidat.medecine_questions.immuned_yf,
        immuned_yf_date: candidat.medecine_questions.immuned_yf_date,
        immuned_yf_comments: candidat.medecine_questions.immuned_yf_comments,
        immuned_ha: candidat.medecine_questions.immuned_ha,
        immuned_ha_date: candidat.medecine_questions.immuned_ha_date,
        immuned_ha_comments: candidat.medecine_questions.immuned_ha_comments,
        immuned_hb: candidat.medecine_questions.immuned_hb,
        immuned_hb_date: candidat.medecine_questions.immuned_hb_date,
        immuned_hb_comments: candidat.medecine_questions.immuned_hb_comments,
        immuned_typhoid: candidat.medecine_questions.immuned_typhoid,
        immuned_typhoid_date: candidat.medecine_questions.immuned_typhoid_date,
        immuned_typhoid_comments: candidat.medecine_questions.immuned_typhoid_comments,
        immuned_meningite: candidat.medecine_questions.immuned_meningite,
        immuned_meningite_date: candidat.medecine_questions.immuned_meningite_date,
        immuned_meningite_comments: candidat.medecine_questions.immuned_meningite_comments,
        immuned_diph: candidat.medecine_questions.immuned_diph,
        immuned_diph_date: candidat.medecine_questions.immuned_diph_date,
        immuned_diph_comments: candidat.medecine_questions.immuned_diph_comments,
        immuned_teta: candidat.medecine_questions.immuned_teta,
        immuned_teta_date: candidat.medecine_questions.immuned_teta_date,
        immuned_teta_comments: candidat.medecine_questions.immuned_teta_comments,
        immuned_covid: candidat.medecine_questions.immuned_covid,
        immuned_covid_date: candidat.medecine_questions.immuned_covid_date,
        immuned_covid_comments: candidat.medecine_questions.immuned_covid_comments,
        immuned_polio: candidat.medecine_questions.immuned_polio,
        immuned_polio_date: candidat.medecine_questions.immuned_polio_date,
        immuned_polio_comments: candidat.medecine_questions.immuned_polio_comments,
        immuned_menin: candidat.medecine_questions.immuned_menin,
        immuned_menin_date: candidat.medecine_questions.immuned_menin_date,
        immuned_menin_comments: candidat.medecine_questions.immuned_menin_comments,
        immuned_rage: candidat.medecine_questions.immuned_rage,
        immuned_rage_date: candidat.medecine_questions.immuned_rage_date,
        immuned_rage_comments: candidat.medecine_questions.immuned_rage_comments
      });
    } else {
      form.setFieldsValue({
        has_heart_disease_high_bp: 0,
        has_epilepsy: 0,
        has_glaucom: 0,
        has_diabete: 0,
        has_cancer_blood_disease: 0,
        has_hereditary_disease: 0,
        has_breath_disease: 0,
        precisions_ant_family: "",
        has_frequent_headach: 0,
        has_dizziness: 0,
        has_trauma: 0,
        has_med_epilepsy: 0,
        has_mental_trouble: 0,
        has_heart_trouble: 0,
        has_hyper_ta: 0,
        has_asthma: 0,
        has_tb_pneumonia: 0,
        has_orl_trouble: 0,
        has_speak_trouble: 0,
        has_tumor_cancer: 0,
        has_skin_trouble: 0,
        has_bone_disease: 0,
        has_kidney_stones: 0,
        has_prostate_trouble: 0,
        is_pregnant: 0,
        has_gastro_inflammation: 0,
        has_gastro_trouble: 0,
        has_rectal_bleed: 0,
        has_med_diabete: 0,
        has_thyroid_disease: 0,
        has_blood_diseases: 0,
        has_sti: 0,
        ant_med_others: "",
        has_allergy: 0,
        has_been_hospitalized: 0,
        has_done_surgery: 0,
        has_tropical_disease: 0,
        has_eye_trouble: 0,
        has_med_cancer_tumor: 0,
        is_workspace_harmful: 0,
        has_weight_loss: 0,
        precisions_ant_med: "",
        is_alcoholic: 0,
        use_intertainment_drugs: 0,
        do_sport_hobbies: 1,
        smokes_tobacco: 0,
        alcohol_frequency: "",
        alcohol_quantity: "",
        cigaret_quantity_day: "",
        sport_type_frequency: "",
        comment_social: "",
        has_advise_work_avoid: 0,
        has_nervous_trouble: 0,
        has_attend_psycho_specialist: 0,
        is_acrophobic_claustrophobic: 0,
        has_aknowledge_work_incapacity: 0,
        has_aknowledge_tasks_security_requirement: 1,
        has_attempt_suicide: 0,
        has_frequent_depression: 0,
        has_transmitted_thinkings: 0,
        has_super_powers: 0,
        has_frequent_irritation: 0,
        has_frequent_nervous_nocontrol: 0,
        is_known_quarrelsome: 0,
        has_frequent_hustle_nervous: 0,
        precisions_psycho: "",
        has_frequent_morning_cough: 0,
        has_frequent_day_night_cough: 0,
        has_frequent_mucositis_day_night: 0,
        has_spit_blood: 0,
        feel_chest_tighten: 0,
        is_bothered_shortness_breath: 0,
        has_day_worse_shortness_breath: 0,
        has_chest_whistle: 0,
        has_last_three_years_chest_disease: 0,
        has_chest_injury_surgery: 0,
        has_heart_disease_tb: 0,
        has_bronchitis_pneumonia_pleurisy: 0,
        has_pulmonary_tb_asthma: 0,
        precisions_tb: "",
        current_medication_type_dosage: "",
        allergy_food: "",
        allergy_drug: "",
        chemical_products: "",
        allergy_others: "",
        has_exposed_chemical: 0,
        chemical_exposition_delay: "",
        used_chemical_protection: 0,
        has_exposed_noise: 0,
        has_exposed_noise_delay: "",
        has_exposed_noise_protection: 0,
        has_exposed_vibrations: 0,
        has_exposed_vibrations_delay: "",
        has_exposed_vibrations_protection: 0,
        has_exposed_radioactivity: 0,
        has_exposed_radioactivity_delay: "",
        has_exposed_radioactivity_protections: 0,
        has_exposed_asbestos_dust: 0,
        has_exposed_asbestos_dust_delay: "",
        has_exposed_asbestos_dust_protection: 0,
        has_exposed_lead: 0,
        has_exposed_lead_delay: "",
        has_exposed_lead_protection: 0,
        has_exposed_other_dust: 0,
        has_exposed_other_dust_delay: "",
        has_exposed_other_dust_protection: 0,
        has_last_year_absent_count: 0,
        has_last_year_absent_reason: "",
        has_last_year_absent: 0,
        has_work_injury_inquiry_compensation: 0,
        work_injury_reason: "",
        work_injury_treatment: "",
        work_injury_stills: 0,
        work_injury_stills_manifestation: "",
        has_work_heavy_engin: 0,
        has_work_lifting_bending: 0,
        has_work_surface_light: 0,
        has_work_stand_long: 0,
        has_work_drive_passengers: 0,
        has_work_office: 0,
        has_work_confined: 0,
        has_work_height: 0,
        has_work_wildlife: 0,
        has_work_sea: 0,
        has_work_underground: 0,
        has_work_high_temperature: 0,
        height: 0,
        weight: 0,
        temperature: 0,
        eye_normal: 1,
        orl_normal: 1,
        teeth_mouth_normal: 1,
        breathe_normal: 1,
        imc: 0,
        cardiovascular_normal: 1,
        abdomen_normal: 1,
        musculoskeletal_normal: 1,
        ends_normal: 1,
        genitourinary_normal: 1,
        comment_clinical_observation: "",
        arterial_pressure: "",
        breathe_frequency: "",
        cardiac_frequency: "",
        heartbeat: 1,
        glucose: "",
        blood: "",
        bilirubine: "",
        leucocytes: "",
        cetone: "",
        proteine: "",
        blood_formula_normal: 1,
        glycemy_normal: 1,
        uree_normal: 1,
        creatine_normal: 1,
        serology_ha_normal: 1,
        serology_hb_normal: 1,
        selle_normal: 1,
        idr_normal: 1,
        cholesterol_normal: 1,
        triglyceride_normal: 1,
        alat_asat_normal: 1,
        gamma_gt_normal: 1,
        //DRUG
        amphetamine_positive: 0,
        benzodiazepine_positive: 0,
        cannabinoide_positive: 0,
        opiace_positive: 0,
        cocain_positive: 0,
        //IM
        rest_ecg_normal: 1,
        effort_ecg_normal: 1,
        radio_normal: 1,
        //VISION
        chrome_vision_normal: 1,
        woglass_right_far: "",
        woglass_right_near: "",
        wglass_right: "",
        visual_area_normal: 1,
        woglass_left_far: "",
        woglass_left_near: "",
        wglass_left: "",
        cvf_measured: "",
        vems_one_measured: "",
        vems_percent_measured: "",
        cvf_forecasted: "",
        vems_one_forecasted: "",
        vems_percent_forcasted: "",
        cvf_percent_forcasted: "",
        vems_one_percent_forcasted: "",
        vems_percent_percent_forcasted: "",
        comments_spiro: "",
        left_ear_normal: 1,
        left_ear_comment: 1,
        right_ear_normal: 1,
        right_ear_comments: "",
        ipa: "",
        immuned_yf: 0,
        immuned_yf_comments: "",
        immuned_ha: 0,
        immuned_ha_comments: "",
        immuned_hb: 0,
        immuned_hb_comments: "",
        immuned_typhoid: 0,
        immuned_typhoid_comments: "",
        immuned_meningite: 0,
        immuned_meningite_comments: "",
        immuned_diph: 0,
        immuned_diph_comments: "",
        immuned_teta: 0,
        immuned_teta_comments: "",
        immuned_covid: 0,
        immuned_covid_comments: "",
        immuned_polio: 0,
        immuned_polio_comments: "",
        immuned_menin: 0,
        immuned_menin_comments: "",
        immuned_rage: 0,
        immuned_rage_comments: ""
      });
    }
  }, []);
  var tabItems = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CardChecklist, {
        size: 23
      }), " QUESTIONNAIRE"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Table, {
              children: /*#__PURE__*/_jsxs("tbody", {
                children: [/*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Image, {
                      preview: false,
                      src: "/drawables/simf.jpeg",
                      width: "220px"
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx("h3", {
                      style: {
                        color: "#1F497D"
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: "HSEC"
                      })
                    })
                  }), /*#__PURE__*/_jsx("td", {})]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Image, {
                      preview: false,
                      src: "/drawables/mlink.png",
                      width: "70px"
                    })
                  }), /*#__PURE__*/_jsxs("td", {
                    colspan: 2,
                    children: [/*#__PURE__*/_jsx("h4", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Projet Simandou"
                      })
                    }), /*#__PURE__*/_jsx("h4", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Manipulateurs de denr\xE9es alimentaires - Formulaire d'\xE9valuation m\xE9dicale pr\xE9-embauche"
                      })
                    })]
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx("h5", {
              children: /*#__PURE__*/_jsx("b", {
                children: "1 - RENSEIGNEMENTS PERSONNELS : \xE0 remplir par le demandeur :"
              })
            }), /*#__PURE__*/_jsx(Table, {
              size: "md",
              striped: true,
              bordered: true,
              hover: true,
              children: /*#__PURE__*/_jsxs("tbody", {
                children: [/*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Pr\xE9noms et nom"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.name
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Date"
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: candidat.created_at,
                      format: "DD/MM/YYYY"
                    })
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Nationalit\xE9"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.nationality
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Employeur"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.company.label
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Fonction/poste"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.job
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Adresse personnelle"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.address
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "T\xE9l\xE9phone"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.mobile_first
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Num\xE9ro de passeport/CI"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.idnumber != 'undefined' && candidat.idnumber
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Date"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.idnumber_expire_date != 'undefined' && /*#__PURE__*/_jsx(Moment, {
                      date: candidat.idnumber_expire_date
                    })
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Adresse mail"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.email != 'undefined' && candidat.email
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Contact d'urgence"
                  }), /*#__PURE__*/_jsxs("td", {
                    colspan: 3,
                    children: [/*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: candidat.sos_person_name
                      })]
                    }), /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "T\xE9l\xE9phones"
                      }), /*#__PURE__*/_jsx("td", {
                        children: candidat.sos_person_mobile
                      })]
                    }), /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Adresse"
                      }), /*#__PURE__*/_jsx("td", {
                        children: candidat.address
                      })]
                    })]
                  })]
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
              form: form,
              disabled: readOnly == 1,
              layout: "vertical",
              size: "small",
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "QUESTIONS SANITAIRES"
                })
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("b", {
                children: "\xC0 remplir par le demandeur avant l\u2019examen m\xE9dical. R\xE9pondez sinc\xE8rement \xE0 toutes les questions. Si vous r\xE9pondez Oui, pr\xE9cisez en d\xE9tail pour chaque cas dans le champ des commentaires ci-dessous."
              }), /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx("i", {
                  children: "Avez-vous d\xE9j\xE0 souffert ou souffrez-vous actuellement de l'une des conditions suivantes ?"
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "1. Ant\xE9c\xE9dents familiaux (parents)"
                        })
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      width: "15%",
                      children: "Oui/Non"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Maladie cardiaque ou hypertension art\xE9rielle"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_heart_disease_high_bp",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "\xC9pilepsie ou convulsions"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_epilepsy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Glaucome ou c\xE9cit\xE9 "
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_glaucom",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Diab\xE8te sucr\xE9 "
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_diabete",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cancer/h\xE9mopathie "
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_cancer_blood_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Maladie h\xE9r\xE9ditaire/anomalies cong\xE9nitales"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_hereditary_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Maladies respiratoires (pneumonie, pneumoconiose, TB, asthme)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_breath_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Pr\xE9cisez int\xE9gralement tous les points o\xF9 vous avez coch\xE9 Oui.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_ant_family",
                        children: /*#__PURE__*/_jsx(TextArea, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "2. Ant\xE9c\xE9dents m\xE9dicaux"
                        })
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Oui/Non"
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.1 Syst\xE8me nerveux central"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "C\xE9phal\xE9es/migraines fr\xE9quentes ou aigu\xEBs"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_headach",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vertiges, \xE9tourdissements ou titubements"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_dizziness",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Traumatisme cr\xE2nien, commotion c\xE9r\xE9brale, \xE9vanouissement"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_trauma",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "\xC9pilepsie ou convulsions"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_med_epilepsy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Trouble mental ou psychologique, phobie"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_mental_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "2.2 Syst\xE8me cardiovasculaire"
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Troubles cardiaques, par ex. rhumatisme articulaire, souffle au c\u0153ur, essoufflement, palpitations, douleurs thoraciques, angine de poitrine ou crise cardiaque"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_heart_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Hypertension art\xE9rielle, cholest\xE9rol \xE9lev\xE9 ou troubles circulatoires dont accident vasculaire c\xE9r\xE9bral, crampes dans les mollets lors d\u2019un exercice physique"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_hyper_ta",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.3 Appareil respiratoire inf\xE9rieur"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Asthme, toux chronique, pneumoconiose"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_asthma",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Tuberculose ou pneumonie"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_tb_pneumonia",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.4 Appareil respiratoire sup\xE9rieur"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Troubles oto-rhino-laryngologiques"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_orl_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Troubles auditifs ou langagiers"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_speak_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.5 Dermatologie et syst\xE8me musculosquelettique"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Tumeurs malignes ou cancer"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_tumor_cancer",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Troubles cutan\xE9s (psoriasis, ecz\xE9ma, acn\xE9)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_skin_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Maladie musculaire, osseuse, articulaire ou dorsale"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_bone_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.6 Appareil urinaire et reproducteur"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Calculs r\xE9naux ou infections urinaires"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_kidney_stones",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Probl\xE8mes prostatiques/gyn\xE9cologiques"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_prostate_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "\xCAtes-vous enceinte ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_pregnant",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.7 Organes abdominaux"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Br\xFBlures gastriques, indigestion fr\xE9quente"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_gastro_inflammation",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Troubles gastriques, h\xE9patiques ou intestinaux"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_gastro_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Saignement rectal"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_rectal_bleed",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.8 Syst\xE8me endocrinien"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Diab\xE8te sucr\xE9"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_med_diabete",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Maladie thyro\xEFdienne, trouble glandulaire"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_thyroid_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "H\xE9mopathies (dr\xE9panocytose, thalass\xE9mie, leuc\xE9mie, h\xE9mophilie)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_blood_diseases",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.9 Maladies infectieuses"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "H\xE9patite B et C, VIH/IST"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_sti",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Autres", /*#__PURE__*/_jsx(Form.Item, {
                        name: "ant_med_others",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Allergies"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_allergy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Hospitalisation pour quelque raison que ce soit"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_been_hospitalized",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Toute intervention ou op\xE9ration chirurgicale"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_done_surgery",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Toute maladie tropicale, par ex. bilharziose ou paludisme"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_tropical_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Probl\xE8mes oculaires"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_eye_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cancer, excroissance ou tumeur de toute nature"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_med_cancer_tumor",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Pensez-vous que votre milieu de travail actuel pourrait nuire \xE0 votre sant\xE9 ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_workspace_harmful",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Perte ou prise de poids inexpliqu\xE9e"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_weight_loss",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Pr\xE9cisez int\xE9gralement tous les points o\xF9 vous avez coch\xE9 Oui.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_ant_med",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "3. Histoire sociale"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Oui/Non"
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Alcool"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_alcoholic",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Drogues r\xE9cr\xE9atives"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "use_intertainment_drugs",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Exercice, sport et loisirs"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "do_sport_hobbies",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Tabagisme"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "smokes_tobacco",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Fumeur",
                            value: 1
                          }, {
                            label: "JAMAIS",
                            value: 0
                          }, {
                            label: "Ex-fumeur",
                            value: 2
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Alcool : \xE0 quelle fr\xE9quence consommez-vous de l\u2019alcool ?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "alcohol_frequency",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Combien en consommez-vous ?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "alcohol_quantity",
                        children: /*#__PURE__*/_jsx(InputNumber, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Combien de cigarettes fumez-vous par jour ?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "cigaret_quantity_day",
                        children: /*#__PURE__*/_jsx(InputNumber, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Quel type d'exercice pratiquez-vous et \xE0 quelle fr\xE9quence ?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "sport_type_frequency",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Commentaires", /*#__PURE__*/_jsx(Form.Item, {
                        name: "comment_social",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "4. Bilan psychologique"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "OUI/NON"
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous a-t-on d\xE9j\xE0 conseill\xE9 de ne pas travailler en hauteur, par quarts, de nuit ou de ne pas faire un travail quelconque ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_advise_work_avoid",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous ou avez-vous d\xE9j\xE0 eu des troubles nerveux ou mentaux, par ex. \xE9pilepsie, \xE9tourdissements, vertiges, \xE9pisodes de faiblesse soudaine, anxi\xE9t\xE9 ou d\xE9pression ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_nervous_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 \xE9t\xE9 dirig\xE9 vers un sp\xE9cialiste, en particulier un psychologue ou psychiatre ou tout autre professionnel de la sant\xE9 pour une \xE9valuation m\xE9dicale, une opinion ou un traitement concernant vos fonctions mentales ou votre \xE9tat \xE9motionnel ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_attend_psycho_specialist",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "\xCAtes-vous acrophobe ou claustrophobe ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_acrophobic_claustrophobic",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous connaissez-vous d'autres probl\xE8mes qui pourraient nuire \xE0 votre capacit\xE9 d'ex\xE9cuter en toute s\xE9curit\xE9 les t\xE2ches pr\xE9vues en travaillant en hauteur ou dans des espaces clos ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_aknowledge_work_incapacity",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous \xE9t\xE9 inform\xE9 des t\xE2ches que vous \xEAtes cens\xE9 effectuer et des exigences s\xE9curitaires du travail en hauteur ou dans des espaces clos ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_aknowledge_tasks_security_requirement",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 tent\xE9 de vous suicider ou eu des id\xE9es suicidaires ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_attempt_suicide",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous sentez-vous souvent triste, d\xE9prim\xE9 ou d\xE9sesp\xE9r\xE9 ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_depression",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous souvent des pens\xE9es qui ne sont pas les v\xF4tres, par ex. message divin, diabolique ou de mauvais esprits ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_transmitted_thinkings",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous consid\xE9rez-vous comme ayant des pouvoirs sp\xE9ciaux, par ex. pouvoir voler sans ailes ni aide ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_super_powers",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous sentez-vous souvent irritable, ou ayant l\u2019impression que tout est un effort ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_irritation",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous sentez-vous souvent nerveux, ou sans aucun contr\xF4le sur vos soucis ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_nervous_nocontrol",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "\xCAtes-vous connu comme querelleur ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_known_quarrelsome",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vous sentez-vous souvent agit\xE9 ou sur les nerfs ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_hustle_nervous",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Pr\xE9cisez int\xE9gralement tous les points o\xF9 vous avez coch\xE9 Oui.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_psycho",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "5. Respiration/tuberculose"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "OUI/NON"
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Toussez-vous habituellement d\xE8s le matin ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_morning_cough",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Toussez-vous habituellement en journ\xE9e ou la nuit ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_day_night_cough",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous habituellement des remont\xE9es de mucosit\xE9s en journ\xE9e ou la nuit ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_mucositis_day_night",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 crach\xE9 du sang ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_spit_blood",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Sentez-vous parfois votre poitrine se serrer, ou votre respiration devenir difficile ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "feel_chest_tighten",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "\xCAtes-vous g\xEAn\xE9 par un essoufflement quand vous vous h\xE2tez sur sol plat ou quand vous montez une l\xE9g\xE8re pente en marchant ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_bothered_shortness_breath",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Votre essoufflement empire-t-il un jour quelconque ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_day_worse_shortness_breath",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Votre poitrine vous semble-t-elle parfois siffler ou chuinter ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_chest_whistle",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Au cours des 3 derni\xE8res ann\xE9es, avez-vous souffert d'une maladie de poitrine qui vous a \xE9loign\xE9 de vos fonctions habituelles pendant une semaine ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_three_years_chest_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 subi une blessure ou op\xE9ration affectant votre poitrine ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_chest_injury_surgery",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 eu des probl\xE8mes cardiaques ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_heart_disease_tb",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 eu bronchite, pneumonie ou pleur\xE9sie ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_bronchitis_pneumonia_pleurisy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Avez-vous d\xE9j\xE0 eu une tuberculose pulmonaire, de l\u2019asthme ou une autre maladie respiratoire ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_pulmonary_tb_asthma",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Pr\xE9cisez int\xE9gralement tous les points o\xF9 vous avez coch\xE9 Oui.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_tb",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "6. Traitement m\xE9dicamenteux"
                      })
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Veuillez indiquer le type et les doses de tous les m\xE9dicaments que vous prenez actuellement.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "current_medication_type_dosage",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "7. Allergies"
                      })
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Veuillez indiquer si vous avez des allergies", /*#__PURE__*/_jsx(Form.Item, {
                        name: "allergy_food",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Nourriture"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "allergy_drug",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "M\xE9dicaments"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "chemical_products",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Produits chimiques"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "allergy_others",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Autres"
                        })
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "QUESTIONNAIRE SUR LA SANT\xC9 AU TRAVAIL :"
                })
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("i", {
                children: "Avez-vous occup\xE9 un poste o\xF9 vous avez \xE9t\xE9 expos\xE9 \xE0 :"
              }), /*#__PURE__*/_jsxs(Table, {
                borderless: true,
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Agent d'exposition"
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Oui/Non"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Date/dur\xE9e de l'exposition"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Protection utilis\xE9e ?"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Produits chimiques"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_chemical",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "chemical_exposition_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "La duree ici"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "used_chemical_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 4,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Si oui precisez"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Bruit"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_noise",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_noise_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "La duree ici"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_noise_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vibrations"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_vibrations",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_vibrations_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Ici la duree"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_vibrations_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Radioactivit\xE9"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_radioactivity",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_radioactivity_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Ici la duree"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_radioactivity_protections",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Poussi\xE8re d\u2019amiante"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_asbestos_dust",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_asbestos_dust_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "La duree ici"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_asbestos_dust_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Plomb"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_lead",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_lead_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "La duree ici"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_lead_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Autres poussi\xE8res (silice, charbon, or,diamant)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_other_dust",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_other_dust_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "La duree ici"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_other_dust_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsxs("td", {
                      colspan: 3,
                      children: ["Vous \xEAtes-vous absent\xE9 du travail au cours de l'ann\xE9e derni\xE8re ? Dans l'affirmative, pour combien de temps et pour quels motifs ?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_year_absent_count",
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          placeholder: "Temps absence"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_year_absent_reason",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Raison de l'absence"
                        })
                      })]
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_year_absent",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Avez-vous d\xE9j\xE0 eu une blessure ou maladie professionnelle ou une demande d\u2019indemnisation en tant qu\u2019employ\xE9 ? Si oui, indiquez :"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_injury_inquiry_compensation",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["Les causes de la maladie ou blessure", /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_reason",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["Le traitement m\xE9dical que vous avez suivi et/ou continuez de suivre", /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_treatment",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Continuez-vous de souffrir des effets d'une blessure ou maladie professionnelle ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_stills",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["Dans l\u2019affirmative, indiquez les sympt\xF4mes que vous continuez \xE0 ressentir :", /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_stills_manifestation",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "La nature de votre travail implique-t-elle ce qui suit ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: "OUI/NON"
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Conduite d\u2019engins de terrassement lourds"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_heavy_engin",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Soul\xE8vement/flexion r\xE9p\xE9titifs"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_lifting_bending",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Travail en surface sur des t\xE2ches physiques l\xE9g\xE8res"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_surface_light",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Posture debout prolong\xE9e"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_stand_long",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Conduite d\u2019un v\xE9hicule de passagers"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_drive_passengers",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Travail de bureau"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_office",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Espace confin\xE9"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_confined",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Travail en hauteur"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_height",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Contact avec la faune"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_wildlife",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Travailler en mer"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_sea",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Travail souterrain"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_underground",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Travail \xE0 haute temp\xE9rature"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_high_temperature",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "Oui",
                            value: 1
                          }, {
                            label: "Non",
                            value: 0
                          }]
                        })
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
                className: "pad cool-radius",
                style: {
                  background: "#CDD6E0",
                  padding: "10px"
                },
                children: [/*#__PURE__*/_jsx(Row, {
                  children: /*#__PURE__*/_jsxs(Col, {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "D\xC9CLARATION DU DEMANDEUR :"
                    }), /*#__PURE__*/_jsx("p", {
                      children: "Je d\xE9clare par la pr\xE9sente qu\u2019\xE0 ma connaissance, les r\xE9ponses \xE0 toutes les questions sont correctes, et n\u2019avoir cach\xE9 aucune information concernant ma sant\xE9 pass\xE9e ou pr\xE9sente."
                    })]
                  })
                }), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "NOM"
                        })
                      }), candidat.name]
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "SIGNATURE"
                        })
                      }), candidat.medecine_questions && candidat.medecine_questions.signature != null || signatureIm != null && signatureIm != "" ? /*#__PURE__*/_jsx(Image, {
                        style: {
                          cursor: "pointer"
                        },
                        preview: false,
                        onClick: function onClick() {
                          if (readOnly == 0) {
                            setShowSignaturePad(true);
                          }
                        },
                        src: signatureIm,
                        width: "100%"
                      }) : /*#__PURE__*/_jsx(_Fragment, {
                        children: readOnly == 0 && /*#__PURE__*/_jsx(Button, {
                          type: "primary",
                          icon: /*#__PURE__*/_jsx(UploadIcon, {
                            size: 20
                          }),
                          onClick: function onClick() {
                            setShowSignaturePad(true);
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: "SIGNER"
                          })
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "DATE"
                        })
                      }), /*#__PURE__*/_jsx(Moment, {
                        date: candidat.created_at,
                        format: "DD/MM/YYYY"
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: " EXAMEN M\xC9DICAL"
                })
              }), /*#__PURE__*/_jsx("p", {
                children: "\xC0 remplir par le m\xE9decin examinateur. Un examen minutieux de tous les syst\xE8mes est demand\xE9, et toutes les rubriques doivent \xEAtre remplies."
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Taille"
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        name: "height",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "CM"
                        })
                      }), " "]
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Poids"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "weight",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "Kg"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "IMC"
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        name: "imc",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: ""
                        })
                      }), " "]
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Temperature"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "temperature",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "\xB0C"
                        })
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Normal/Anormal"
                      })
                    }), /*#__PURE__*/_jsx("td", {})]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Yeux"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "eye_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      rowspan: 10,
                      children: /*#__PURE__*/_jsx(Image, {
                        src: "drawables/body.png",
                        width: "240px"
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Oreilles, nez et gorge"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "orl_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Dents et bouche"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "teeth_mouth_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Respiration"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "breathe_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Cardiovasculaire"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cardiovascular_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Abdomen"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "abdomen_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Musculosquelettique"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "musculoskeletal_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Extr\xE9mit\xE9s"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "ends_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "G\xE9nito-urinaire"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "genitourinary_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["Commentaires sur les constats cliniques :", /*#__PURE__*/_jsx(Form.Item, {
                        name: "comment_clinical_observation",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Pression art\xE9rielle"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "arterial_pressure",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "mmHg"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Fr\xE9quence respiratoire"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "breathe_frequency",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "Respiration/Min"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Fr\xE9quence cardiaque"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cardiac_frequency",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "BPM"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Rythme cardiaque"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "heartbeat",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "REGULIER",
                            value: 1
                          }, {
                            label: "IRREGULIER",
                            value: 0
                          }]
                        })
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "5 - ANALYSE EN LABORATOIRE"
                })
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  padding: "15px",
                  textAlign: "center",
                  borderRadius: "5px",
                  border: "1px solid #E77C6B"
                },
                children: "Veuillez joindre les r\xE9sultats de tout test s'ils ne figurent pas dans ce formulaire."
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsxs("p", {
                  children: [/*#__PURE__*/_jsx("h5", {
                    children: /*#__PURE__*/_jsx("b", {
                      children: "GROUPE SANGUIN"
                    })
                  }), /*#__PURE__*/_jsx("span", {
                    children: "Tester si inconnu"
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    textAlign: "center",
                    background: "#E7DFDE",
                    minWidth: "180px",
                    padding: "10px",
                    borderRadius: "4px",
                    minHeight: "100px"
                  },
                  children: candidat.laboratory_result && candidat.laboratory_result.hemato && /*#__PURE__*/_jsxs("h2", {
                    children: [candidat.laboratory_result.hemato.groupe, " ", candidat.laboratory_result.hemato.rhesus.toLowerCase().indexOf("neg") > -1 ? "-" : "+"]
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "ANALYSE URINAIRE:"
                })
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("thead", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Glucose"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "glucose",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Sang"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "blood",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Bilirubine"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "bilirubine",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Leucocytes"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "leucocytes",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "C\xE9tone"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cetone",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Prot\xE9ine"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "proteine",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "ANALYSE SANGUINES:"
                })
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Num\xE9ration et formule sanguines"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "blood_formula_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Glyc\xE9mie \xE0 jeun"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "glycemy_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Ur\xE9e"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "uree_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cr\xE9atinine"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "creatine_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "S\xE9rologie H\xE9patite A"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "serology_ha_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "S\xE9rologie de l\u2019h\xE9patite B"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "serology_hb_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Selles (personnel de cuisine seulement)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "selle_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "IDR Tuberculine (personne de cuisine)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "idr_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cholest\xE9rol (total, HDL, LDL)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cholesterol_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Triglyc\xE9rides"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "triglyceride_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "ALAT- ASAT"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "alat_asat_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Gamma GT"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "gamma_gt_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "D\xC9PISTAGE URINAIRE DES DROGUES :"
                })
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Amph\xE9tamines"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "amphetamine_positive",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "POSITIF",
                            value: 1
                          }, {
                            label: "NEGATIF",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Benzodiaz\xE9pines"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "benzodiazepine_positive",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "POSITIF",
                            value: 1
                          }, {
                            label: "NEGATIF",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cannabino\xEFdes"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cannabinoide_positive",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "POSITIF",
                            value: 1
                          }, {
                            label: "NEGATIF",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Opiac\xE9s"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "opiace_positive",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "POSITIF",
                            value: 1
                          }, {
                            label: "NEGATIF",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Coca\xEFne"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cocain_positive",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "POSITIF",
                            value: 1
                          }, {
                            label: "NEGATIF",
                            value: 0
                          }]
                        })
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
                style: {
                  padding: "15px",
                  background: "#E7DFDE",
                  borderRadius: "9px 9px 9px 0px"
                },
                children: [/*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "ECG AU REPOS"
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: "Veuillez fixer le c\xE2ble ECG."
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "rest_ecg_normal",
                  label: "Constatations",
                  rules: [{
                    required: true,
                    message: "Champs obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: "NORMAL",
                      value: 1
                    }, {
                      label: "ANORMAL",
                      value: 0
                    }]
                  })
                }), /*#__PURE__*/_jsx("h5", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "ECG \xC0 L\u2019EFFORT (si cliniquement indiqu\xE9)"
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "effort_ecg_normal",
                  label: "Constatations",
                  rules: [{
                    required: true,
                    message: "Champs obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: "NORMAL",
                      value: 1
                    }, {
                      label: "ANORMAL",
                      value: 0
                    }]
                  })
                })]
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "RADIOGRAPHIE THORACIQUE : veuillez joindre le clich\xE9 radiographique"
                })
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  padding: "15px",
                  background: "#E7DFDE",
                  borderRadius: "9px 9px 9px 0px"
                },
                children: /*#__PURE__*/_jsx(Form.Item, {
                  name: "radio_normal",
                  label: "Constatations",
                  rules: [{
                    required: true,
                    message: "Champs obligatoire"
                  }],
                  children: /*#__PURE__*/_jsx(Radio.Group, {
                    optionType: "button",
                    buttonStyle: "solid",
                    options: [{
                      label: "NORMAL",
                      value: 1
                    }, {
                      label: "ANORMAL",
                      value: 0
                    }]
                  })
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "EXAMEN DE LA VISION :"
                })
              }), /*#__PURE__*/_jsx(Table, {
                responsive: true,
                striped: true,
                bordered: true,
                hover: true,
                size: "md",
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vision:"
                    }), /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      rowspan: 0.5,
                      children: /*#__PURE__*/_jsx("div", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "SANS LUNETTES"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "AVEC LUNETTES"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "chrome_vision_normal",
                        label: "Vision chromatique",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ROUGE/VERT",
                            value: 0
                          }, {
                            label: "AUTRES",
                            value: 2
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Droit"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "woglass_right_far",
                        label: "\xC9loign\xE9e",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "woglass_right_near",
                        label: "Rapproch\xE9e",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: " ",
                        name: "wglass_right",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      rowspan: 2,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "visual_area_normal",
                        label: "Champs visuels",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Gauche"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "\xC9loign\xE9e",
                        name: "woglass_left_far",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "Rapproch\xE9e",
                        name: "woglass_left_near",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: " ",
                        name: "wglass_left",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {})]
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "SPIROM\xC9TRIE : veuillez joindre le rapport complet (tous les 2 ans)"
                })
              }), /*#__PURE__*/_jsxs(Table, {
                responsive: true,
                bordered: true,
                striped: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "CVF"
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "VEMS 1"
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "VEMS %"
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Mesur\xE9"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cvf_measured",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "vems_one_measured",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "vems_percent_measured",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Pr\xE9vu"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cvf_forecasted",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "vems_one_forecasted",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "vems_percent_forcasted",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "% Pr\xE9vu"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cvf_percent_forcasted",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "vems_one_percent_forcasted",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "vems_percent_percent_forcasted",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 4,
                      children: /*#__PURE__*/_jsxs("b", {
                        children: ["Transmettre si ratio VEMS 1/CVF ", ">", " 70 %"]
                      })
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 4,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "Commentez en d\xE9tail toutes les anomalies",
                        name: "comments_spiro",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "AUDIOM\xC9TRIE : veuillez joindre l'audiogramme"
                })
              }), /*#__PURE__*/_jsxs(Table, {
                responsive: true,
                bordered: true,
                striped: true,
                hover: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {}), /*#__PURE__*/_jsx("th", {
                      children: "Normal/Anormal"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Commentaires"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Oreille gauche"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "left_ear_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "left_ear_comment",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Oreille droite"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "right_ear_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ANORMAL",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "right_ear_comments",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("h6", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "IPA :"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "ipa",
                        children: /*#__PURE__*/_jsx(Input, {
                          addonAfter: "%"
                        })
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "VACCINATION"
                })
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  padding: "15px",
                  background: "#E7DFDE",
                  borderRadius: "9px 9px 9px 0px"
                },
                children: [/*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Veuillez indiquer le statut vaccinal du demandeur et tout vaccin administr\xE9. Une copie du \xAB carnet de vaccinations internationales \xBB ou de la \xAB fiche d\u2019immunisation \xBB doit \xEAtre jointe \xE0 ce formulaire."
                  })
                }), /*#__PURE__*/_jsx("p", {
                  children: "Veillez \xE0 souligner l\u2019importance des vaccins et \xE0 indiquer dans la section des commentaires si le demandeur a refus\xE9 l\u2019un des vaccins."
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
                responsive: true,
                hover: true,
                striped: true,
                bordered: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: "Vaccin"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Immunis\xE9"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Date"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Commentaire"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 4,
                      children: "Obligatoire : "
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Fi\xE8vre jaune"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_yf",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_yf_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_yf_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Personnel de cuisine"
                    }), /*#__PURE__*/_jsx("td", {
                      colspan: 3
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "H\xE9patite A"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_ha",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_ha_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_ha_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "H\xE9patite B"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_hb",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_hb_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_hb_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Typho\xEFde"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_typhoid",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_typhoid_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_typhoid_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "M\xE9ningite"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_meningite",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_meningite_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_meningite_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Dipht\xE9rie"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_diph",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_diph_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_diph_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "T\xE9tanos"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_teta",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_teta_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_teta_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 4,
                      children: "Fortement recommand\xE9 :"
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Covid 19"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_covid",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_covid_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_covid_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "H\xE9patite A"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_ha",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_ha_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_ha_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "H\xE9patite B"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_hb",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_hb_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_hb_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "T\xE9tanos"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_teta",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_teta_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_teta_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Polio"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_polio",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_polio_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_polio_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "M\xE9ningococcie"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_menin",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_menin_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_menin_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Dipht\xE9rie"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_diph",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_diph_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_diph_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Rage*"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_rage",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "OUI",
                            value: 1
                          }, {
                            label: "NON",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_rage_date",
                        children: /*#__PURE__*/_jsx(DatePicker, {
                          placeholder: "",
                          format: "DD/MM/YYYY"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "immuned_rage_comments",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx("i", {
                  children: "(*) Fortement recommand\xE9 aux employ\xE9s qui pourraient \xEAtre en contact avec la faune dans le cadre de leur travail."
                })
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#E7DFDE",
                  padding: "10px",
                  borderRadius: "6px"
                },
                children: [/*#__PURE__*/_jsx("p", {
                  children: "D\xE9claration \xE0 signer par l\u2019employ\xE9(e) s\u2019il/si elle refuse un vaccin."
                }), /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "\xAB Je d\xE9clare par la pr\xE9sente avoir refus\xE9 l\u2019administration des vaccins susmentionn\xE9s, ce apr\xE8s avoir pris connaissance de leur recommandation et eu \xE9gard au profil de risque \xE9pid\xE9miologique \xE9lev\xE9 de la Guin\xE9e. Ma d\xE9cision concernant le vaccin a \xE9t\xE9 prise en toute connaissance de cause. \xBB"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    borderRadius: "6px",
                    padding: "8px",
                    background: "#EEE"
                  },
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h5", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "NOM"
                          })
                        }), candidat.name]
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h5", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "SIGNATURE"
                          })
                        }), candidat.medecine_questions && candidat.medecine_questions.signaturenv != null || signatureNoVaccin != null && signatureNoVaccin != "" ? /*#__PURE__*/_jsx(Image, {
                          style: {
                            cursor: "pointer"
                          },
                          preview: false,
                          onClick: function onClick() {
                            if (readOnly == 0) {
                              setShowNoVaccinSignaturePad(true);
                            }
                          },
                          src: signatureNoVaccin,
                          width: "100%"
                        }) : /*#__PURE__*/_jsx(_Fragment, {
                          children: readOnly == 0 && /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            icon: /*#__PURE__*/_jsx(UploadIcon, {
                              size: 20
                            }),
                            onClick: function onClick() {
                              setShowNoVaccinSignaturePad(true);
                            },
                            children: /*#__PURE__*/_jsx("b", {
                              children: "SIGNER"
                            })
                          })
                        })]
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h5", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "DATE"
                          })
                        }), /*#__PURE__*/_jsx(Moment, {
                          date: candidat.created_at,
                          format: "DD/MM/YYYY"
                        })]
                      })
                    })]
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), readOnly == 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  loading: isFormProcessing,
                  type: "primary",
                  size: "large",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "SAUVEGARDER"
                  })
                })
              })]
            })]
          })
        })]
      })
    })
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tabs, {
      items: tabItems,
      animated: true
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "SIGNER L'AUTHENTICITE DES REPONSES DONNEES"
      }),
      footer: null,
      width: "70%",
      open: showSignaturePad,
      onCancel: function onCancel() {
        setShowSignaturePad(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(SignaturePad, {
        s_im: setSignatureIm,
        form_type: formType,
        candidat: candidat,
        handler: function handler() {
          setShowSignaturePad(false);
          notification.success({
            message: "Signature enregistrées"
          });
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "SIGNER LA DECHARGE"
      }),
      footer: null,
      width: "70%",
      open: showNoVaccinSignaturePad,
      onCancel: function onCancel() {
        setShowNoVaccinSignaturePad(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(SignaturePadNoVaccin, {
        s_im: setSignatureNoVaccin,
        form_type: formType,
        candidat: candidat,
        handler: function handler() {
          setShowNoVaccinSignaturePad(false);
          notification.success({
            message: "Signature enregistrées"
          });
        }
      })
    })]
  });
};
export default MedFormFhPe;